<template>
  <div class="download-module">
    <div class="download-module__wrapper">
      <h6 class="subtitle">
        {{ subtitle }}
      </h6>
      <h3 class="title">
        {{ title }}
      </h3>
      <ButtonPrimary
        :label="button"
        isBlack
        :iconAfter="icons[icon]"
        :url="baseUrl + url"
        :componentTitle="title"
        componentType="download module"
      />
    </div>
  </div>
</template>

<script setup>
import ButtonPrimary from "@/components/atoms/ButtonPrimary.vue";
import { download } from "@/assets/icons/icons.js";
import { inject } from "vue";

const icons = { download };
defineProps({
  title: String,
  subtitle: String,
  button: String,
  icon: String || undefined,
  url: String,
});

const baseUrl = inject("$baseUrl");
</script>

<style lang="scss" scoped>
.download-module {
  padding: 0 var(--page-padding-h);

  border-bottom: var(--section-border);

  &__wrapper {
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    color: var(--color-black);
    padding: 3.12rem 0;
    @include lineLeft;
  }

  .subtitle {
    @include p-xs-bold;
  }

  .title {
    @include title-l;
  }
}
</style>
